import {forwardRef} from 'react'
import Svg, {Circle, Path} from 'react-native-svg'

import {useDeerVerification} from '#/state/preferences/deer-verification'
import {useTheme} from '#/alf'
import {type Props, useCommonSVGProps} from '#/components/icons/common'
import {accentForeground} from '#/features/themes/accentForeground'

export const VerifiedCheck = forwardRef<Svg, Props>(
  function LogoImpl(props, ref) {
    const theme = useTheme()
    const {perVerifierBadges} = useDeerVerification()
    const {fill, size, style, ...rest} = useCommonSVGProps(props)

    return (
      <Svg
        fill="none"
        {...rest}
        ref={ref}
        viewBox="0 0 24 24"
        width={size}
        height={size}
        style={[style]}>
        <Circle cx="12" cy="12" r="11.5" fill={fill} />
        <Path
          fill={accentForeground(
            perVerifierBadges ? {...theme, onAccent: undefined} : theme,
            typeof fill === 'string' ? fill : theme.palette.primary_500,
          )}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.659 8.175a1.361 1.361 0 0 1 0 1.925l-6.224 6.223a1.361 1.361 0 0 1-1.925 0L6.4 13.212a1.361 1.361 0 0 1 1.925-1.925l2.149 2.148 5.26-5.26a1.361 1.361 0 0 1 1.925 0Z"
        />
      </Svg>
    )
  },
)
